import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Icon,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
// import GlobalSelectField from '../../../components/mui/GlobalSelectField';
import { Field } from 'formik';
import GlobalFileUploadComponent from '../../../components/Fileupload/GlobalFileUploadComponent';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import GlobalHelperTextFormik from '../../../components/GlobalHelperTextFormik';
import { getCourseUnderProject } from '../../../redux/features/courseSlice';
// import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getEmbedUrl } from './utils/Functions';
import GlobalSelectField from '../../../components/mui/GlobalSelectField';
import { LANGUAGE_PREFERENCE } from '../../../utils/constants/languagePreference';
import { getLanguage } from '../../../redux/features/generalSlice';
import { useSelector } from 'react-redux';
import GlobalMultiSelectFormik from '../../../components/mui/GlobalMultiSelectFormik';
import GlobalAllTypeFileUpload from '../../../components/Fileupload/GlobalAllTypeFileUpload';

export default function FirstStepAddCourse({ formik, projectslist, setStep, handleClose }) {
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const language = useSelector((state) => state.general.language);

  // const courseUnderProject = useSelector((state) => state.course.courseUnderProject);
  // const courseUnderProjectLoading = useSelector((state) => state.course.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLanguage(1));
  }, [dispatch]);

  useEffect(() => {
    formik.values?.project && dispatch(getCourseUnderProject(formik.values?.project));
  }, [formik.values?.project, dispatch]);

  return (
    <Box sx={{ p: { xs: 1, sm: 0.5 } }}>
      <Stack spacing={3} sx={{ width: '100%' }}>
        {/* Basic details */}
        {/*  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ width: '100%' }}>
          <GlobalSelectField
            options={{
              label: 'Project',
              data: projectslist,
              keys: { id: 'id', value: 'name' },
              name: 'project',
              formik,
              sx: {
                width: '100%',
              },
            }}
          />
          <GlobalSelectField
            options={{
              label: 'Course',
              data: courseUnderProject,
              keys: { id: 'course_available_id', value: 'course_name' },
              name: 'course_available_id',
              formik,
              sx: {
                width: '100%',
              },
            }}
            disabled={courseUnderProjectLoading}
          />
        </Stack> */}

        <Field
          as={TextField}
          fullWidth
          label="Title"
          placeholder="Type the course title"
          name="title"
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
        />

        {/*   <Box>
          <GlobalFileUploadComponent
            formik={formik}
            fileBackendLink="titleImageUrl"
            fileDisplayName="titleImageUrlDisplay"
            accept="image/*"
            label="Title Image"
          />
          <GlobalHelperTextFormik formik={formik} name={'titleImageUrlDisplay'} />
        </Box> */}

        <Divider />

        {/* Course type */}
        <Box>
          <Typography fontSize={14} fontWeight={600} mb={1}>
            Course Type
          </Typography>
          <RadioGroup row name="courseType" value={formik.values.courseType} onChange={formik.handleChange}>
            <FormControlLabel value="Academic" control={<Radio size="small" />} label="Academic" />
            <FormControlLabel value="Non Academic" control={<Radio size="small" />} label="Non Academic" />
          </RadioGroup>
          <GlobalHelperTextFormik formik={formik} name={'courseType'} />
        </Box>

        {/* Age range */}
        <Box>
          <Typography fontSize={14} fontWeight={600} mb={1}>
            Age Range
          </Typography>
          <Stack spacing={2}>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={2}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1, width: '100%' }}>
                <Typography width={40} variant="body2">
                  From
                </Typography>
                <Slider
                  value={formik.values.ageFrom}
                  max={18}
                  sx={{ flex: 1 }}
                  onChange={(_, value) => formik.setFieldValue('ageFrom', value)}
                />
                <TextField
                  size="small"
                  onChange={(e) => {
                    const MAX = 18;
                    const value = Number(e.target.value);
                    return formik.setFieldValue('ageFrom', value <= MAX ? value : MAX);
                  }}
                  type="number"
                  value={`${formik.values.ageFrom}`}
                  sx={{ width: 50 }}
                  inputProps={{ style: { textAlign: 'center' } }}
                />
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1, width: '100%' }}>
                <Typography width={40} variant="body2">
                  To
                </Typography>
                <Slider
                  value={formik.values.ageTo}
                  sx={{ flex: 1 }}
                  onChange={(_, value) => formik.setFieldValue('ageTo', value)}
                  max={100}
                />
                <TextField
                  size="small"
                  value={`${formik.values.ageTo}`}
                  onChange={(e) => {
                    const MAX = 100;
                    const value = Number(e.target.value);
                    return formik.setFieldValue('ageTo', value <= MAX ? value : MAX);
                  }}
                  type="number"
                  sx={{ width: 55 }}
                  inputProps={{ style: { textAlign: 'center' } }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Box>

        {/* Duration & lessons */}
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ width: '100%' }}>
          <Field
            as={TextField}
            fullWidth
            type="number"
            label="Duration"
            placeholder="Type the minimum sessions"
            name="duration"
            error={formik.touched.duration && Boolean(formik.errors.duration)}
            helperText={formik.touched.duration && formik.errors.duration}
          />
          <Field
            as={TextField}
            type="number"
            fullWidth
            label="Lessons"
            placeholder="Type the number of lessons"
            name="lessons"
            error={formik.touched.lessons && Boolean(formik.errors.lessons)}
            helperText={formik.touched.lessons && formik.errors.lessons}
          />
        </Stack>

        {/* Language & certificate */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          sx={{ width: '100%' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          {/* <GlobalSelectField
            options={{
              formik,
              label: 'Language Preference',
              data: LANGUAGE_PREFERENCE,
              keys: {
                id: 'id',
                value: 'value',
              },
              name: 'language',
              setFieldName: 'value',
              sx: {
                width: '100%',
              },
            }}
          /> */}
          <GlobalMultiSelectFormik
            formik={formik}
            name={'language'}
            data={language}
            keys={{
              id: 'subject_id',
              value: 'subject_name',
            }}
            label={'Language Preference'}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            <Typography fontSize={14} fontWeight={600}>
              Certificate
            </Typography>
            <RadioGroup row name="certificate" value={formik.values.certificate} onChange={formik.handleChange}>
              <FormControlLabel value={true} control={<Radio size="small" />} label="Yes" />
              <FormControlLabel value={false} control={<Radio size="small" />} label="No" />
            </RadioGroup>
          </Box>
        </Stack>

        <Divider />

        {/* Uploads */}
        <Box>
          {/* <GlobalFileUploadComponent
            formik={formik}
            fileBackendLink="brochureUrl"
            fileDisplayName="brochureUrlDisplay"
            accept=".pdf,image/*"
            label="Brochure Upload"
            updateLabel="Update Brochure"
          />
          <GlobalHelperTextFormik formik={formik} name={'brochureUrlDisplay'} /> */}
          <GlobalAllTypeFileUpload
            accept="image/*,video/*,audio/*,application/pdf"
            dbFolderName="course"
            formik={formik}
            label="Brochure Upload"
            formikNameArray="brochureUrl"
            // multiple
            typeSize={{
              pdf: 50,
            }}
          />
          <GlobalHelperTextFormik formik={formik} name={'brochureUrl'} />
        </Box>

        <Box>
          <Typography fontSize={14} fontWeight={600} mb={1}>
            Testimonial Video
          </Typography>
          {Boolean(formik.values.testimonialVideoLink?.length > 2) ? (
            <Box width={'100%'} position={'relative'}>
              <Button
                sx={{
                  position: 'absolute',
                  right: 0,
                }}
                onClick={() => setVideoDialogOpen(true)}
                variant="contained"
              >
                edit
              </Button>
              <iframe
                title="unique-one"
                src={getEmbedUrl(formik.values.testimonialVideoLink)}
                width="100%"
                height="200"
                style={{ border: 0, borderRadius: '10px' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          ) : (
            <Paper
              onClick={() => setVideoDialogOpen(true)}
              elevation={0}
              sx={{
                border: '1px dashed',
                borderColor: 'primary.light',
                height: 120,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                bgcolor: 'grey.50',
                borderRadius: 1.5,
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: 'primary.50',
                },
              }}
            >
              <Stack alignItems="center" spacing={1}>
                <Icon icon="material-symbols:link" width={32} />
                <Typography fontSize={13} color="text.secondary">
                  {formik.values.testimonialVideoLink ? 'Video link added' : 'Click to add testimonial video link'}
                </Typography>
              </Stack>
            </Paper>
          )}
          <GlobalHelperTextFormik formik={formik} name={'testimonialVideoLink'} />
        </Box>

        <GlobalDialog
          open={videoDialogOpen}
          setOpen={setVideoDialogOpen}
          title="Add Testimonial Video"
          maxWidth="sm"
          fullWidth
          content={
            <Stack spacing={2}>
              <Field
                as={TextField}
                fullWidth
                name="testimonialVideoLink"
                label="Video URL"
                placeholder="https://youtube.com/..."
                value={formik.values.testimonialVideoLink}
                error={formik.touched.testimonialVideoLink && Boolean(formik.errors.testimonialVideoLink)}
                helperText={formik.touched.testimonialVideoLink && formik.errors.testimonialVideoLink}
              />

              <Box display="flex" justifyContent="flex-end" gap={1}>
                <Button
                  onClick={() => {
                    setVideoDialogOpen(false);
                    formik.setFieldValue('testimonialVideo', '');
                  }}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  onClick={() => {
                    setVideoDialogOpen(false);
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Stack>
          }
        />
        <Box>
          {/* <GlobalFileUploadComponent
            formik={formik}
            fileBackendLink="courseBannerUrl"
            fileDisplayName="courseBannerUrlDisplay"
            accept="image/*"
            label="Course Banner Upload"
            updateLabel="Update Course Banner"
          />
          <GlobalHelperTextFormik formik={formik} name={'courseBannerUrlDisplay'} /> */}
          <GlobalAllTypeFileUpload
            accept="image/*,video/*,audio/*,application/pdf"
            dbFolderName="course"
            formik={formik}
            label="Course Banner Upload"
            formikNameArray="courseBannerUrl"
            typeSize={{
              pdf: 50,
            }}
          />
          <GlobalHelperTextFormik formik={formik} name={'courseBannerUrl'} />
        </Box>

        {/* Actions */}
        <Box display="flex" justifyContent="flex-end" mt={1} gap={1}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" color="primary" size="small" type="submit">
            Next
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
